import useController from './useController';
import {Page} from '../../common/constant/page';
import {sendViewerEvent} from '../common';
import ControllBar from '../component/controllBar/ControllBar';
import {IViewType, IViewerEpisode} from '../type';

interface IProps {
  isPrevInactive: boolean;
  isNextInactive: boolean;
  isStopSales: boolean;
  isHideController: boolean;
  contentId?: number;
  episodeId: number;
  viewType: IViewType;
  prevPage: Page;
  prevEpisode?: IViewerEpisode;
  nextEpisode?: IViewerEpisode;
  goToPrevEpisode: () => void;
  goToNextEpisode: () => void;
}

export default function Controller({
  isPrevInactive,
  isNextInactive,
  isStopSales,
  contentId,
  episodeId,
  viewType,
  prevPage,
  prevEpisode,
  nextEpisode,
  goToPrevEpisode,
  goToNextEpisode,
}: IProps) {
  const {
    isShow,
    isRunMode,
    runModeRef,
    onClickComment,
    onClickRunMode,
    onClickAutoScroll,
  } = useController();

  const onClick = (actionName: IControllActionName) => {
    if (contentId) {
      const targetEpisodeId =
        actionName === 'pre_episode' && prevEpisode
          ? prevEpisode.id
          : actionName === 'next_episode' && nextEpisode
            ? nextEpisode.id
            : episodeId;
      sendViewerEvent({
        actionName,
        action: 'click',
        customProps: {
          content_id: contentId,
          episode_id: targetEpisodeId,
          viewer_type: viewType,
          event_layer: 'controller',
        },
      });
    }

    switch (actionName) {
      case 'pre_episode':
        goToPrevEpisode();
        break;
      case 'next_episode':
        goToNextEpisode();
        break;
      case 'comment':
        onClickComment();
        break;
      case 'auto_scroll':
        onClickAutoScroll({showToast: prevPage !== Page.Viewer});
        break;
      case 'binge':
        onClickRunMode();
        break;
    }
  };

  return (
    <ControllBar
      isShow={isShow}
      isPrevInactive={isPrevInactive}
      isNextInactive={isNextInactive}
      isStopSales={isStopSales}
      isRunMode={isRunMode}
      runModeRef={runModeRef}
      viewType={viewType}
      onClickPrevEpisode={() => !isRunMode && onClick('pre_episode')}
      onClickComment={() => onClick('comment')}
      onClickRunMode={() => onClick('binge')}
      onClickNextEpisode={() => !isRunMode && onClick('next_episode')}
      onClickAutoScroll={() => onClick('auto_scroll')}
    />
  );
}

type IControllActionName =
  | 'pre_episode'
  | 'next_episode'
  | 'episode_list'
  | 'comment'
  | 'auto_scroll'
  | 'binge';
